import { useState } from "react";
import { Send, Gift } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter?email=${encodeURIComponent(email)}`);
      toast.success("Successfully subscribed! Check your inbox for exclusive offers.");
      setEmail("");
    } catch (error) {
      toast.error("Failed to subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-12 bg-muted/30">
      <div className="max-w-3xl mx-auto px-4">
        <div className="glass rounded-2xl p-6 md:p-8 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/20 text-primary text-xs font-medium mb-4">
            <Gift className="w-3 h-3" />
            <span>Exclusive Offers</span>
          </div>

          <h2 className="text-2xl font-bold text-white mb-2 font-['Montserrat']">
            Get Exclusive <span className="text-secondary">Bonuses</span>
          </h2>
          
          <p className="text-white/60 mb-5 text-sm max-w-md mx-auto">
            Subscribe for the latest casino, slots & crash game bonuses delivered to your inbox.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-muted border-border text-white placeholder:text-muted-foreground h-10 rounded-full px-4"
              data-testid="newsletter-email-input"
              required
            />
            <Button 
              type="submit" 
              disabled={loading}
              className="btn-glow gradient-neon text-white font-semibold h-10 px-6 rounded-full flex items-center gap-2 text-sm"
              data-testid="newsletter-submit-btn"
            >
              {loading ? (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                <>
                  <Send className="w-3 h-3" />
                  Subscribe
                </>
              )}
            </Button>
          </form>

          <p className="text-white/40 text-xs mt-3">
            No spam. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
}
